import React from 'react';
import { Button, Space } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, InfoCircleOutlined, ContactsOutlined, CustomerServiceOutlined, ContainerOutlined, ScheduleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Navigation = ({ mode = "horizontal" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: t('navigation.home'),
    },
    {
      key: '/about',
      icon: <InfoCircleOutlined />,
      label: t('navigation.about'),
    },
    {
      key: '/contact',
      icon: <ContactsOutlined />,
      label: t('navigation.contact'),
    },
  ];

  const buttonStyle = {
    borderRadius: '20px',
    margin: '0 5px',
    background: 'rgba(255, 255, 255, 0.9)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    height: '40px',
    paddingLeft: '16px',
    paddingRight: '16px',
    fontWeight: '600', // Make text thicker
  };

  const activeButtonStyle = {
    ...buttonStyle,
    background: '#1890ff',
    color: 'white',
  };

  const defaultButtonStyle = {
    borderRadius: '20px', // Keep consistent rounded shape
    fontWeight: '600', // Make text thicker
    height: '40px',
    paddingLeft: '16px',
    paddingRight: '16px',
  };

  return (
    <Space
      direction={mode === 'horizontal' ? 'horizontal' : 'vertical'}
      style={{ 
        flex: 1,
        justifyContent: 'center',
        padding: '10px 0',
      }}
    >
      {navItems.map(item => {
        const isActive = location.pathname === item.key;
        return isActive ? (
          <Button
            key={item.key}
            icon={item.icon}
            style={activeButtonStyle}
            onClick={() => navigate(item.key)}
          >
            {item.label}
          </Button>
        ) : (
          <Button
            key={item.key}
            type="text"
            icon={item.icon}
            style={defaultButtonStyle} // Apply default style for inactive buttons
            onClick={() => navigate(item.key)}
            className="nav-button" // Add a class for custom hover in CSS
          >
            {item.label}
          </Button>
        );
      })}
      <style jsx>{`
        .nav-button:hover {
          background-color: rgba(24, 144, 255, 0.1) !important;
          border-radius: 20px !important;
        }
      `}</style>
    </Space>
  );
};

export default Navigation;
